import { toBase58 } from 'shared/utils/b58';
import settings from 'shared/settings';
import { STATUS_COLOR_MAP } from './booking-status-theming';
export function getVideoCallLink(booking) {
  const shortBookingId = toBase58(booking?.id || '');
  const videoCallLink = settings.getShortUrl(`/v/${shortBookingId}`);
  return videoCallLink;
}
export const statusToColorScale = (theme, status) => {
  return STATUS_COLOR_MAP[status] || 'gray';
};
import { DateTime } from 'luxon';
import { getTranslation } from './text';
export const bookingToString = (booking, serviceData, locationData, businessLanguage, showStatus = false) => {
  return `${[booking.services[0]].map(bs => bs.service_id ? getTranslation(serviceData[bs.service_id]?.name, businessLanguage) : bs.service_name || 'Removed').join(', ')} ${DateTime.fromISO(booking.services[0].start, {
    zone: locationData[booking.location_id]?.timezone || 'UTC'
  }).toFormat('ff')} ${showStatus ? ` - ${booking.status}` : ''}`;
};
export const getBookingUrl = bookingId_ => {
  const bookingId = toBase58(bookingId_ || '');
  const url = settings.getShortUrl(`/b/${bookingId}`);
  return url;
};
export const getVideoCallUrl = bookingId_ => {
  const formId = toBase58(bookingId_ || '');
  const url = settings.getShortUrl(`/v/${formId}`);
  return url;
};